import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { ProcedimentoSelectModel } from 'components/form/field/select/ProcedimentoSelectField'
import { RastreioCancerInput, RastreioCancerPerguntaDbEnum, TipoExameEnum } from 'graphql/types.generated'
import { SoapEditableItem } from 'view/atendimentos/atendimento-individual/model'
import { LotacaoAtendimento } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { ExameListSelectFieldModel } from './components/ExameListSelectField'
import { RequisicaoExameCitopatologicoFormValues } from './components/requisicao-exame/citopatologico/model-citopatologico'
import { RequisicaoExameMamografiaFormValues } from './components/requisicao-exame/mamografia/model-mamografia'

export interface SolicitacaoExameModel extends SoapEditableItem {
  _id: ID
  examesSolicitados: ExameListSelectFieldModel[]
  tipoExame: TipoExameEnum
  cid10?: CidSelectFieldModel
  justificativa: string
  observacao?: string
  rastreioCitopatologicoColoUtero?: RequisicaoExameCitopatologicoFormValues
  rastreioMamografia?: RequisicaoExameMamografiaFormValues
}

export interface ExameSolicitadoMergedModel {
  id: ID
  exame: ProcedimentoSelectModel
  observacao?: string
  conferido?: boolean
}

export interface SolicitacaoExameMergedModel extends Omit<SolicitacaoExameModel, '_id' | 'examesSolicitados'> {
  examesSolicitados: ExameSolicitadoMergedModel[]
}

export interface ItemHistoricoSolicitacaoExameModel extends SoapEditableItem {
  id: ID
  solicitacao: SolicitacaoExameMergedModel
  data: Instant
  adicionadoAgora: boolean
  title: string
  codigos: string
  atendimentoProfissionalId: ID
  lotacao: LotacaoAtendimento
  questoesCitopatologico?: Map<RastreioCancerPerguntaDbEnum, string>
  questoesMamografia?: Map<RastreioCancerPerguntaDbEnum, string>
}

export interface SolicitacaoExamesProcedimento {
  idExame: ID
  observacoes?: string
}

export interface SolicitacaoExameReport {
  examesRequisitados: SolicitacaoExamesProcedimento[]
  justificativa: string
  observacoes?: string
  cid10?: ID
  tipoExame: TipoExameEnum
}

export interface ImpressaoSolicitacaoExamesInput {
  id?: ID
  idAtendimentoProfissional: ID
  prontuarioId: ID
  atendimentoId?: ID
  idCidadao: ID
  solicitacao?: SolicitacaoExameReport
}

export interface ImpressaoRequisicaoRastreioCancerBaseInput {
  atendProfId: ID
  prontuarioId: ID
  atendimentoId?: ID
}

export interface ImpressaoRequisicaoRastreioCancerInput extends ImpressaoRequisicaoRastreioCancerBaseInput {
  rastreioCancer: ReadonlyArray<RastreioCancerInput>
}

export const CODIGO_MAMOGRAFIAS: string[] = ['0204030030', '0204030188']
export const CODIGO_CITOPATOLOGICOS: string[] = [
  'ABPG010',
  '0201020033',
  '0203010019',
  '0203010086',
  '0201020076',
  '0201020084',
  '0202100251',
]
export const CODIGOS_GERAM_REQUISICAO: string[] = CODIGO_CITOPATOLOGICOS.concat(CODIGO_MAMOGRAFIAS)
